import { cn } from '../../utils/cn';

export default function Card({ className, padded = true, children, ...rest }) {
  return (
    <div
      className={cn(
        // Shared Zuzzuu 2.0 kart — zuzzuu_customers GridTable App kutusuyla
        // hizalı: 20 px (1.25rem) radius, #E1E1E1 kenarlık, yumuşak gölge.
        'bg-white rounded-[1.25rem] border border-[#E1E1E1] shadow-card',
        padded && 'p-6',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action, className }) {
  return (
    <div className={cn('flex items-start justify-between gap-4 mb-4', className)}>
      <div>
        <h3 className="text-base font-semibold text-neutral-900">{title}</h3>
        {subtitle && <p className="text-sm text-neutral-500 mt-0.5">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
